import * as Consts from '../consts'

import * as Filters from './Filters'

import createLogger from 'debug'
export const log = createLogger('module:project')

export const resolveImageUrl = (path) =>
  `https://www.arch-log.com/cdn_images/${path}`

/**
 */
export const resolvePropertyType = (value) => {
  const v = Consts.PropertyTypes.find((v) => v.key == value)

  return v ? v.value : null
}

/**
 */
export const resolveConstructionType = (value) => {
  const v = Consts.ConstructionTypes.find((v) => v.key == value)

  return v ? v.value : null
}

/**
 */
export const resolveConstructionArea = (value) => {
  const v = Consts.ConstructionAreas.find((v) => v.key == value)

  return v ? v.value : null
}

/**
 */
export { Filters }
